// extracted by mini-css-extract-plugin
export var animationSkeleton = "EmptyFallback-module--animationSkeleton--8c149";
export var skeleton = "EmptyFallback-module--skeleton--73124";